import { User } from '../../../types';

const NullUser: User = {
  id: '',
  verifiedAt: null,
  email: '',
  firstName: '',
  insertion: '',
  lastName: '',
  fullName: '',
  roles: [],
};

export default NullUser;
